import React, { useEffect, useState } from 'react';
import useUserProfiles from '../../../user/hooks/useUserProfiles';
import CTableInvestors from './components/CTableInvestors';
import { Checkbox, FormControlLabel, Grid, TextField } from '@mui/material';
import AppCustomIcon from '../../../../app/features/icon/AppIcon';
import IUserProfile from '../../interfaces/IUserProfile';
import langAdminInvestors from '../../langs/langAdminInvestors';
import { useTranslation } from 'react-i18next';

const AdminInvestorsList = () => {
	const { data: investors } = useUserProfiles();

	const [keywords, setKeywords] = useState('');

	const { t } = useTranslation();

	const [bDisplayDelete, setBDisplayDelete] = useState<boolean>(false);
	const [bDisplayInactive, setBDisplayInactive] = useState<boolean>(true);

	const [investorsFiltered, setInvestorsFiltered] = useState<IUserProfile[]>([]);
	useEffect(() => {
		if (investors) {
			setInvestorsFiltered(
				investors
					.filter((x) => x.importDeletionTime === null || bDisplayDelete)
					.filter((x) => x.isAccountActivated === true || bDisplayInactive)
					.filter(
						(x) =>
							x.companies.some((c) => c.name.toLowerCase().includes(keywords.toLowerCase())) ||
							(x.firstName && x.firstName.toLowerCase().includes(keywords.toLowerCase())) ||
							(x.lastName && x.lastName.toLowerCase().includes(keywords.toLowerCase())) ||
							(x.email && x.email.toLowerCase().includes(keywords.toLowerCase())),
					),
			);
		}
	}, [keywords, investors, bDisplayDelete, bDisplayInactive]);

	const [investorsForRedirect, setInvestorsForRedirect] = useState<IUserProfile[]>([]);
	useEffect(() => {
		if (window.location.search && investors) {
			const urlParams = new URLSearchParams(window.location.search);
			const companys = urlParams.get('companys')?.split(',');

			companys &&
				setInvestorsForRedirect(
					investors.filter((x) => x.companies.some((c) => companys.includes(c.id.toString()))),
				);
		}
	}, [investors]);

	return (
		<>
			<Grid container spacing={3}>
				<Grid item sm={6}>
					<TextField
						variant="outlined"
						fullWidth
						size="small"
						label={t(langAdminInvestors.keywords.tag)}
						value={keywords}
						onChange={(event) => setKeywords(event.target.value)}
						sx={{
							'& .MuiOutlinedInput-root': {
								borderRadius: '45px',
							},
							'& .MuiInputBase-input': {
								paddingLeft: '10px',
							},
							marginBottom: '15px',
						}}
						InputProps={{
							startAdornment: <AppCustomIcon tag="search" />,
						}}
					/>
				</Grid>
				<Grid item sm={3}>
					<FormControlLabel
						control={
							<Checkbox checked={bDisplayDelete} onChange={() => setBDisplayDelete(!bDisplayDelete)} />
						}
						label={t(langAdminInvestors.display_deleted_accounts.tag)}
					/>
				</Grid>
				<Grid item sm={3}>
					<FormControlLabel
						control={
							<Checkbox
								checked={bDisplayInactive}
								onChange={() => setBDisplayInactive(!bDisplayInactive)}
							/>
						}
						label={t(langAdminInvestors.display_disabled_accounts.tag)}
					/>
				</Grid>
			</Grid>
			{investors && (
				<CTableInvestors
					investors={investorsFiltered}
					investorsForRedirect={investorsForRedirect}
					hideColumns={!bDisplayDelete ? ['importDeletionTime'] : []}
				/>
			)}
		</>
	);
};

export default AdminInvestorsList;
